/**
 * Staging environment settings
 *
 * This file is where you define overrides for any of the config settings that
 * should only be applied in the staging environment.
 *
 * The production environment is defined as 'process.env.LORE_ENV=staging'
 */

export default {

  /**
   * To override a config setting, specify the name of the config file you
   * want to override, followed by the settings you want to change.
   */

  auth0: {
    clientID: 'gYoDeBb1I25NlBrj75yz4QGYrb2UV7ig', // Staging SPA (staging tenant)
    redirectUri: 'https://app-staging.communityshare.org/auth/callback',
  },

  connections: {
    default: {
      apiRoot: 'https://api-staging.communityshare.org/community_v3'
    }
  },

  custom: {
    stewardUrl: function() {
      return `https://steward-staging.communityshare.org`;
    },
    turnstileSiteKey: "0x4AAAAAADurKdylECP3rr3b"
  },

  intercom: {
    appId: 'x2vk07yc',
    companyId: 'staging',
    companyName: 'Staging'
  },

  raven: {
    environment: 'staging',
    enabled: true
  },

  fullstory: {
    enabled: false
  },

  dialogs: {
    showTransitions: true
  },

  statsig: {
    environment: 'staging'
  }

}
